import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/executors/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/executors/:executorId/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/executors/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR_BULK]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/executors/bulk_create_executors/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].PUT_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/executors/:executorId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/executors/:executorId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/executors/:executorId/',
		requestOptions: {
			method: 'DELETE',
		},
	},

}